module.exports = __webpack_public_path__ + "img/icon_sy.144d1c5d.png";